// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"3fdee8fe","554":"cd34f405","716":"2ca7041f","787":"24f09276","896":"0d8e8f4d"}[chunkId] + ".chunk.js";
};